import api from './base';

class CHLinkedCHsApi {
  private path = '/cHLinkedCHs';

  public getList = async (params: any): Promise<any> => {
    const { data } = await api.get(this.path, { params });
    return data;
  };
}

export default new CHLinkedCHsApi();
